import { Table } from "antd";
import { useKycRefine } from "hook/base/kyc/useKyc";
import React from "react";
import { getTime } from "util/time.function";
import TableStatus from "./table_status";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycTable = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useKycRefine();

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Gửi lúc",
      dataIndex: "createAt",
      key: "createAt",
      render: (_, record) => getTimeCreateAt(record),
    },
    {
      title: "Tên file",
      dataIndex: "fileName",
      key: "fileName",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 120,
      fixed: "right",
      render: (_, record) => <TableStatus record={record} />,
    },
  ];

  const getTimeCreateAt = (record) => {
    const timeAt = record?.reUpAt || record?.createAt;
    return getTime(timeAt, "DD/MM/YYYY HH:mm:ss");
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Table
      size="small"
      bordered
      rowKey={"id"}
      columns={columns}
      dataSource={data}
      loading={data === null}
      scroll={{ x: "auto" }}
    />
  );
};
export default KycTable;
